// Mi aprendizaje · portada de curso Pizarra: las reglas puras de su geometría (la pantalla y las pruebas las usan).
// Una composición por curso («A» o «B»), adaptada a la tarjeta del catálogo (16:9) y a la cabecera del curso (ancha en
// la computadora, menos en el celular). El nombre del curso nunca baja de 16 px: si no entra, la portada crece en alto.

export const TITLE_MIN = 16;
/** The proportions of each place: catalog card 16:9; course header wide on desktop, less on a phone. */
export const coverRatio = (shape, w) => (shape === 'card' ? 16 / 9 : w > 600 ? 900 / 210 : 358 / 160);

/**
 * The geometry of a cover for a width (pure: the screen and the tests use it). Returns the sizes of the zones and the
 * title size; the title never goes under 16 px (the height grows instead).
 */
export function coverGeometry({ layout, shape = 'card', w, hasImage, titleLength = 20 }) {
  const h = w / coverRatio(shape, w);
  const pad = Math.max(12, Math.round(w * 0.045));
  const wide = shape === 'header' && w / h > 3;
  const imgW = hasImage ? Math.round(w * (wide ? 0.34 : layout === 'A' ? 0.42 : 0.4)) : 0;
  const row = w / h > 2.2;
  const rr = row ? Math.min((h - 2 * pad) / 2.6, w * 0.035) : Math.min((h - 2 * pad) / 7.4, w * 0.05);
  const decorW = !hasImage && layout === 'A' ? Math.round((row ? rr * 7.6 : rr * 2.4) + pad) : 0;
  const kicker = Math.max(10.5, Math.round(h * (shape === 'card' ? 0.065 : 0.07)));
  const lenF = titleLength <= 30 ? 1 : titleLength <= 50 ? 0.82 : 0.7;
  const title = Math.max(TITLE_MIN, Math.round(h * (shape === 'card' ? 0.2 : wide ? 0.26 : 0.22) * lenF));
  return { h, pad, imgW, row, rr, decorW, kicker, title };
}

/** The image's position and zoom (CSS) from its framing; wide zones show the upper part by default. */
export function imageStyle(cover) {
  const x = Math.max(-1, Math.min(1, Number(cover?.x) || 0));
  const y = Math.max(-1, Math.min(1, (Number(cover?.y) || 0) + 0.6));
  const pos = `${50 + x * 50}% ${50 - y * 50}%`;
  const zoom = Math.max(1, Math.min(2.5, Number(cover?.zoom) || 1));
  return { width: '100%', height: '100%', objectFit: 'cover', objectPosition: pos, transform: `scale(${zoom})`, transformOrigin: pos, display: 'block' };
}

